<template>
<div v-if="visible" class="loading-overlay">
  <div class="loading-spinner">
    <div class="loading-bounce"></div>
    <div class="loading-bounce"></div>
    <div class="loading-bounce"></div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-spinner {
  width: 75px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-bounce {
  width: 15px;
  height: 15px;
  margin: 0 5px;
  background-color: #fff;
  border-radius: 50%;
  animation: loading-bounce 1.4s infinite ease-in-out;
}

.loading-bounce:nth-child(2) {
  animation-delay: 0.2s;
}

.loading-bounce:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes loading-bounce {
  0%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-15px);
  }
}
</style>



// WEBPACK FOOTER //
// LxmLoading.vue?f72a9a9c